import {
  base_colorAction,
  base_colorContentBorder,
  base_contentHover,
  base_contentSelected,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_regular,
  font_sm,
  fontH2,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(2)};
  align-items: flex-start;
  padding: ${spacing(3)};
  min-width: 232px;
  height: 102px;
  justify-content: space-between;
  border-radius: ${spacing(2)};
  border: 1px solid ${base_colorContentBorder};

  .StatisticsBox-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: ${spacing(2)};

    .StatisticsBox-header-left {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: ${spacing(2)};

      .StatisticsBox-header-left-label {
        color: ${text_colorTextSecondary};
        font-family: ${font_family_weight_regular};
        ${font_sm};
        // defining the max-width here ensures that the label can wrap
        // if needed without affecting the surrounding icons
        max-width: 140px;
      }
    }
  }

  .StatisticsBox-value {
    color: ${base_colorAction};
    ${fontH2};
  }

  &:hover {
    cursor: pointer;
    background: ${base_contentHover};
  }

  &.active {
    background: ${base_contentSelected};
  }
`
